// import React from "react";

// import { AW22 } from "../../../../js/database/database-aw22.js";

// import TopMenuProducts from "../../../../components/topmenuproducts";
// import SwiperInit from "../../../../components/SwiperInit";
// import InfoItem from "../../../../components/infoItem";
// import Loader from "../../../../components/loader";
// import ShopifyMainComponent from "../../../../components/ShopifyMainComponent";
// import SizeChart from "../../../../components/sizeChart.js";

// class CharcoalLizardBlazer extends React.Component {
//   render() {
//     return (
//       <div>
//         <Loader />
//         <TopMenuProducts name={AW22.jackets.CharcoalLizardBlazer.itemName} />
//         <InfoItem
//           price={AW22.jackets.CharcoalLizardBlazer.itemPrice}
//           fabric={AW22.jackets.CharcoalLizardBlazer.itemFabric}
//         />
//         <SizeChart src={AW22.jackets.CharcoalLizardBlazer.sizeChart} />

//         <div className="swiper-container" id="swiper">
//           <div className="swiper-wrapper">
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.CharcoalLizardBlazer.picture01}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.CharcoalLizardBlazer.picture02}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.CharcoalLizardBlazer.picture03}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.CharcoalLizardBlazer.picture04}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.CharcoalLizardBlazer.picture05}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//             <div className="swiper-slide">
//               <img
//                 src={AW22.jackets.CharcoalLizardBlazer.picture06}
//                 alt={AW22.alt}
//                 loading="lazy"
//               />
//             </div>
//           </div>
//         </div>
//         <ShopifyMainComponent
//           divId={AW22.jackets.CharcoalLizardBlazer.shopifyDivId}
//           mainId={AW22.jackets.CharcoalLizardBlazer.shopifyId}
//         />

//         <SwiperInit />
//       </div>
//     );
//   }
// }

// export default CharcoalLizardBlazer;

import React from "react";

import { AW22 } from "../../../../js/database/database-aw22.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const CharcoalLizardBlazer = () => {
  return (
    <ProductsContainer
      pageTitle={AW22.jackets.CharcoalLizardBlazer.itemName}
      name={AW22.jackets.CharcoalLizardBlazer.itemName}
      price={AW22.jackets.CharcoalLizardBlazer.itemPrice}
      fabric={AW22.jackets.CharcoalLizardBlazer.itemFabric}
      src={AW22.jackets.CharcoalLizardBlazer.sizeChart}
      divId={AW22.jackets.CharcoalLizardBlazer.shopifyDivId}
      mainId={AW22.jackets.CharcoalLizardBlazer.shopifyId}
    >
      {React.Children.toArray(
        AW22.jackets.CharcoalLizardBlazer.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW22.jackets.CharcoalLizardBlazer.itemName}
              width={AW22.imgWidth}
              height={AW22.imgHeight}
              loading={AW22.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default CharcoalLizardBlazer;
